<template>
    <div>
        <form @submit.prevent="saveSettlementSettings()" id="settlement_form">
            <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('label.settlement_settings') }}
                    </div>
                    <div>
                        <kt-form-group class="my-2">
                            <div class="custom-control custom-switch">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       id="skip_settlement"
                                       name="skip_settlement"
                                       v-model="settlement.skip_settlement"
                                >
                                <label class="custom-control-label" for="skip_settlement">
                                    {{ $t('label.skip_settlement') }}
                                </label>
                            </div>
                        </kt-form-group>
                        <kt-form-group class="my-4">
                            <label for="settlement_period">
                                {{ $t('label.settlement_period') }}
                            </label>
                            <select id="settlement_period"
                                    class="form-control"
                                    name="settlement_period"
                                    v-model="settlement.settlement_period"
                            >
                                <option v-for="(item, index) in settlementPeriod"
                                        :key="index"
                                        v-text="settlementPeriodStr.get(item)"
                                        :value="item"
                                >
                                </option>
                            </select>
                        </kt-form-group>
                        <kt-form-group class="my-4">
                            <label for="allotment_type">
                                {{ $t('label.allotment_type') }}
                            </label>
                            <select id="allotment_type"
                                    class="form-control"
                                    name="allotment_type"
                                    v-model="settlement.allotment_type"
                            >
                                <option v-for="(item, index) in allotmentType"
                                        :key="index"
                                        v-text="allotmentTypeStr.get(item)"
                                        :value="item"
                                >
                                </option>
                            </select>
                        </kt-form-group>
                        <kt-form-group v-if="settlement.allotment_type === allotmentType.directDebit" class="my-4">
                            <label for="company_id">
                                {{ $t('label.settlement_target') }}
                            </label>

                            <select id="company_id"
                                    class="form-control"
                                    name="company_id"
                                    @change="changeCompanyId"
                                    v-model="settlement.company_id"
                            >
                                <option v-for="(item, index) in settlementTarget"
                                        :key="index"
                                        v-text="settlementTargetStr.get(item)"
                                        :value="item"
                                >
                                </option>
                            </select>
                        </kt-form-group>
                        <kt-form-group class="my-4">
                            <label for="wallet_hashid">
                                {{ $t('label.wallet_hashid') }}
                            </label>
                            <input id="wallet_hashid"
                                    class="form-control"
                                    name="wallet_hashid"
                                    v-model="settlement.wallet_hashid"
                            >
                        </kt-form-group>
                    </div>
                </kt-form-section>
                <kt-form-action class="mt-4">
                    <kt-row>
                        <kt-col xs="12" md="6">
                            <button
                                    class="btn btn-md btn-success btn-wide"
                                    type="submit"
                                    id="save_settlement_changes"
                            >
                                {{ $t('btn.save') }}
                            </button>
                        </kt-col>
                        <kt-col xs="12" md="6" v-if="resend_request_btn">
                          <button
                              class="btn btn-md btn-dark"
                              id="resend_request"
                              @click.prevent="resendRequest()"
                          >
                            {{ $t('btn.resend_request') }}
                          </button>
                        </kt-col>
                    </kt-row>
                </kt-form-action>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {settlementPeriod, settlementPeriodStr} from "@/constants/settlementPeriod";
    import {gatewayService} from "@/common/api.service";
    import $ from "jquery";
    import {allotmentTypeStr, allotmentType} from "@/constants/allotmentType";
    import toastr from "toastr";
    import {KTApp} from "@/plugins/core/app";
    import {settlementTarget, settlementTargetStr} from "@/constants/settlementTarget";

    export default {
        computed: {
            ...mapGetters('gateway', {
                gateway: 'form_data',
                status: 'status'
            }),
            toastr() {
              toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
              }

              return toastr
            },
        },
        data() {
            return {
                settlement: {
                    skip_settlement: false,
                    settlement_period: settlementPeriod.EVERY_DAY,
                    allotment_type: allotmentType.normal,
                    company_id: null,
                },
                settlementPeriod,
                settlementPeriodStr,
                allotmentType,
                allotmentTypeStr,
                settlementTarget,
                settlementTargetStr,
                resend_request_btn: false,
                is_starshop: this.$route.params.gateway_source === 'starshop-gateways'
            };
        },
        methods: {
            changeCompanyId() {
                if (this.settlement.allotment_type !== allotmentType.directDebit) {
                    this.settlement.company_id = null;
                }
            },
            resendRequest() {
              let form = $('#settlement_form');
              let btn = $('#resend_request')

              KTApp.progress(btn)

              gatewayService.resendRequest(this.gateway.id, this.is_starshop)
                  .then((response) => {
                    this.showMsg(form, 'success', response.data.message);
                  })
                  .catch((response) => {
                    console.log(response);
                  })
                  .finally(() => {
                    KTApp.unprogress(btn)
                  })
            },
            saveSettlementSettings() {
                let form = $('#settlement_form');

                let params = {
                    skip_settlement: this.settlement.skip_settlement,
                    settlement_period: this.settlement.settlement_period,
                    wallet_hashid: this.settlement.wallet_hashid,
                    allotment_type: this.settlement.allotment_type,
                    company_id: this.settlement.company_id,
                };

                gatewayService.setTerminalSettlementSettings(this.$route.params.hashid, params, this.is_starshop)
                .then(res => {
                    this.showMsg(form, 'success', res.data.message);
                })
                .catch(({response}) => {
                  if (response.status >= 400 && response.status < 500)
                    this.showMsg(form, 'danger', response.data.message)
                  else
                    this.toastr.error('خطای سرور!')
                })
                .finally(() => {
                  this.getSettlementSettings()
                });
            },
            getSettlementSettings() {
                gatewayService.getTerminalSettlementSettings(this.$route.params.hashid, this.is_starshop).then(res => {
                    this.settlement.skip_settlement = res.data.data.skip_settlement;
                    this.settlement.settlement_period = res.data.data.settlement_period;
                    this.settlement.wallet_hashid = res.data.data.wallet_hashid;
                    this.settlement.allotment_type = res.data.data.allotment_type;
                    this.settlement.company_id = res.data.data.company_id;
                    this.resend_request_btn = res.data.data.allotment_type == allotmentType.allotmentToPf;
                }).catch(err => {
                    console.error('cant fetch settlement settings');
                });
            },
        },
        mounted() {
            this.getSettlementSettings();
        }
    }
</script>

<style scoped>
</style>
